import * as React from "react";
import { CollapseIcon } from "./Icons";

interface Props {
  children?: React.ReactNode;
  onCollapse: () => void;
}

function ActionPopover(props: Props) {
  return (
    <>
      <div className="velaro-overlay" />
      <div className="velaro-action-popover-container">
        <div className="action-popover-header">
          <button
            onClick={props.onCollapse}
            role="button"
            aria-label="Minimize Popover"
          >
            <CollapseIcon color={"#000"} />
          </button>
        </div>
        <div className="action-popover-content">{props.children}</div>
      </div>
    </>
  );
}

export default ActionPopover;
